 <template>
  <div id="app">
    <!-- <notifications group="foo" position="bottom right" /> -->
    <transition name="fade">
      <router-view />
    </transition>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "app",
  data() {
    return {};
  },
  components: {},
  methods: {
    leadSquareIntegration() {
      const script = document.createElement("script");
      script.src = "https://web-us11.mxradon.com/t/Tracker.js";
      document.body.appendChild(script);

      script.onload = function () {
        pidTracker("59187");
      };
      script.onerror = function () {};
    },
  },
  mounted() {
    this.leadSquareIntegration();
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue